export default {"src":"/_next/static/media/gray-room-names.fe9fd2b9.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};